import React from 'react';

import './Loader.css';

const loader = props => (
  // <div className="loader">
  //   <div />
  //   <div />
  //   <div />
  //   <div />
  // </div>
  <div className="c-loading" style={{backgroundColor: "hsla(0,0%,100%,1)"}}>
    <div className="c-loading__container">
      <div className="c-loading__loading-img"></div>
    </div>
  </div>
);

export default loader;
